"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useValidateBanner = useValidateBanner;
function useValidateBanner(_ref) {
  var actionsTheme = _ref.actionsTheme,
    primaryAction = _ref.primaryAction,
    secondaryAction = _ref.secondaryAction;
  var allowed = true;
  var error = '';
  if (!primaryAction && secondaryAction) {
    allowed = false;
    error = 'You have to set primary action before setting a secondary action';
  }
  if (secondaryAction && actionsTheme === 'button-link') {
    allowed = false;
    error = "You can't use the button-link as the main action in case you have more then one action";
  }
  if (!allowed) {
    throw new Error(error);
  }
}
//# sourceMappingURL=useValidateBanner.js.map